import axios from './axios';
import SETTINGS from '../settings'
export default {
    getUserInfo(id, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/userinfo`,{
            params: {
                idCompany: id
            }
        } ).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    updateUserContentFieldOption(payload, cb) {
      axios.post(`${SETTINGS.API_BASE_PATH}/usercontentfieldoption`, payload).then(response => {
        cb(response.data)
      }).catch(e => {
        cb(e)
      })
    },
    deleteUserContentFieldOption(id, cb) {
      axios.delete(`${SETTINGS.API_BASE_PATH}/usercontentfieldoption/${id}`).then(response => {
        cb(response.data)
      }).catch(e => {
        cb(e)
      })
    },
    updateUserProfile(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/saveuserprofile`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    updateUserPhoto(file, cb) {
        //saveuserimage
        axios.post(`${SETTINGS.API_BASE_PATH}/saveuserimage`, file).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    createPublicUser(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/userpublic`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    logUserAccessContent(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/useraccesscontent`, payload).then(response => {
            if(cb) {
                cb(response.data)
            }
        }).catch(e => {
            if(cb) {
                cb(e)
            }
        })
    }
}